import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tbdc-legend-section"
}
const _hoisted_2 = { class: "tbdc-legend-title" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("message.catchmentArea")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (legendItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: legendItem.ID,
            class: "tbdc-legend-row"
          }, [
            _createElementVNode("span", {
              class: "tbdc-legend-swatch",
              style: _normalizeStyle({ 'background-color': legendItem.color })
            }, null, 4),
            _createElementVNode("span", {
              innerHTML: _ctx.convertTitle(legendItem.title)
            }, null, 8, _hoisted_3)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}